import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BLOG_CATEGORIES } from "@/data/site";
import { ArrowRight, Search } from "lucide-react";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    const [cat, setCat] = useState("All");
    const [q, setQ] = useState("");

    useEffect(() => {
        api.get("/blogs").then((r) => setPosts(r.data)).catch(() => {});
    }, []);

    const filtered = posts.filter((p) =>
        (cat === "All" || p.category === cat) &&
        (q === "" || p.title.toLowerCase().includes(q.toLowerCase()) || p.excerpt.toLowerCase().includes(q.toLowerCase()))
    );

    return (
        <div data-testid="blog-page" className="pt-32 pb-20">
            <div className="container-vv">
                <div className="max-w-3xl">
                    <div className="label-eyebrow">Wisdom Journal</div>
                    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream mt-4 text-balance">
                        Insights from the <span className="italic text-gold">stars</span>.
                    </h1>
                    <p className="mt-6 text-cream-muted leading-relaxed text-lg">
                        Deep-dives into Vedic astrology, numerology, planetary transits, monthly horoscopes, remedies, panchang, and nakshatras.
                    </p>
                </div>

                {/* Filters */}
                <div className="mt-12 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
                    <div className="flex flex-wrap gap-2">
                        {BLOG_CATEGORIES.map((c) => (
                            <button
                                key={c}
                                onClick={() => setCat(c)}
                                data-testid={`blog-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`text-xs px-4 py-2 rounded-full border transition-all ${
                                    cat === c ? "bg-gold text-ink border-gold" : "border-gold/30 text-cream hover:border-gold"
                                }`}
                            >
                                {c}
                            </button>
                        ))}
                    </div>
                    <div className="relative max-w-xs w-full">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-cream-muted" />
                        <input
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="Search articles..."
                            className="input-luxe pl-10 text-sm"
                            data-testid="blog-search"
                        />
                    </div>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filtered.map((b) => (
                        <Link key={b.slug || b.id} to={`/blog/${b.slug}`} className="card-luxe p-0 overflow-hidden block group" data-testid={`blog-card-${b.slug}`}>
                            <div className="aspect-[16/10] overflow-hidden">
                                <img src={b.cover_url} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                            </div>
                            <div className="p-6">
                                <div className="text-[10px] tracking-widest uppercase text-gold mb-3">{b.category}</div>
                                <h3 className="font-serif text-xl text-cream leading-snug mb-2">{b.title}</h3>
                                <p className="text-sm text-cream-muted line-clamp-2 mb-4">{b.excerpt}</p>
                                <span className="text-xs text-gold flex items-center gap-1">Read article <ArrowRight className="h-3 w-3" /></span>
                            </div>
                        </Link>
                    ))}
                </div>

                {filtered.length === 0 && (
                    <div className="mt-12 text-center text-cream-muted py-16">No articles found.</div>
                )}
            </div>
        </div>
    );
}
